import { ReactElement, useEffect } from 'react';
import styles from './onboarding-welcome.module.scss';
import { UIButton, UISpacer, UIText, UITextButton } from '@/ui';
import { useCompaniesTranslation } from '../hooks';

import safepointGuy from '../assets/images/safepoint-guy.png';

type OnboardingWelcomeProps = {
    onContinue?: () => void;
    onBack?: () => void;
};

export function OnboardingWelcome(props: OnboardingWelcomeProps): ReactElement {
    const { t } = useCompaniesTranslation();

    const { onContinue, onBack } = props;

    useEffect(() => {
        const handleKeyPress = (event: KeyboardEvent) => {
            if (event.key === 'Enter' && onContinue) {
                onContinue();
            }
        };

        document.addEventListener('keydown', handleKeyPress);

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [onContinue]);

    return (
        <div className={styles.container}>
            <div className={styles.firstBodyHalf}>
                <img
                    src={safepointGuy}
                    alt={t('components.onboarding_welcome.image_alt')}
                    className={styles.image}
                />
            </div>
            <div className={styles.secondBodyHalf}>
                <div className={styles.content}>
                    <UIText variant="h1" bold>
                        {t('components.onboarding_welcome.title')}
                    </UIText>
                    <UISpacer multiplier={1} />
                    <UIText type="default2">
                        {t('components.onboarding_welcome.message')}
                    </UIText>
                    <UISpacer multiplier={2} />
                    <div className={styles.buttonContainer}>
                        <UIButton variant={'primary'} onClick={onContinue}>
                            {t('shared.labels.continue')}
                        </UIButton>
                        <UISpacer multiplier={2} />
                        <UITextButton onClick={onBack}>
                            {t('shared.labels.back')}
                        </UITextButton>
                    </div>
                </div>
            </div>
        </div>
    );
}
